import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => styles(theme));

function AuthBodyAlert ({ ...otherProps }) {
    const classes = useStyles();
    return (
        <Alert
            classes={{ 
                root: classes.root,
                standardSuccess: classes.standardSuccess,
                standardError: classes.standardError
            }}
            {...otherProps}
        />
    );
}

const styles = (theme) => ({
    root: {
        marginTop: `-${theme.constants.auth.verticalMargin * 0.25}px`,
        marginBottom: `${theme.constants.auth.verticalMargin * 0.25}px !important`
    },
    standardError: {
        color: 'rgb(97, 26, 21)',
        // backgroundColor: 'rgb(253, 236, 234)'
    },
    standardSuccess: {
        color: 'rgb(30, 70, 32)',
        // backgroundColor: 'rgb(237, 247, 237)'
    }
});

export default AuthBodyAlert;